module.exports = __webpack_public_path__ + "img/c04_unitstartechchainmail_Normal_ua.b7181237.webp";